import { Action } from '@ngrx/store';

export enum SiteIdAction {
  Set = '[SiteId] Set',
  Reset = '[SiteId] Reset',
  Sync = '[SiteId] Sync',
}

export class Set implements Action {
  readonly type = SiteIdAction.Set;

  constructor(public payload: number) {}
}

export class Reset implements Action {
  readonly type = SiteIdAction.Reset;
}

export class Sync implements Action {
  readonly type = SiteIdAction.Sync;

  constructor(public payload: number[]) {}
}

export type SiteIdActionType = Set | Reset | Sync;
